import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/format";
import { useStoreSettings } from "@/lib/settings.functions";

export function WhatsappFloat() {
  const settings = useStoreSettings();
  return (
    // O <aside> nomeado garante que o botão flutuante fique dentro de uma
    // landmark (leitores de tela ignoram conteúdo solto fora delas). O
    // aria-label no <a> garante o nome acessível do link em qualquer
    // viewport, já que o texto visível some abaixo do breakpoint sm.
    <aside aria-label="Atendimento por WhatsApp">
      <a
        href={whatsappLink(settings.whatsapp_number, "Olá! Tenho uma dúvida sobre a loja.")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco pelo WhatsApp"
        className="fixed bottom-5 right-5 z-30 flex items-center gap-2 rounded-full bg-green-700 px-4 py-3 text-white shadow-xl hover:bg-green-800 transition-colors"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="hidden sm:inline text-sm font-medium">Dúvidas? Fale conosco</span>
      </a>
    </aside>
  );
}
